// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://engage.stage.truventor.com/",
  socketUrl: "wss://engage.stage.truventor.com/",
  meetingUrl:"https://engage.stage.truventor.com/",
  // apiUrl: "http://localhost:3988/",
  // socketUrl: "wss://localhost:3988/",
  // meetingUrl: "http://localhost:3988/",
  // jitsiDomain: "meet.jit.si",
  jitsiDomain: "8x8.vc",
  // jitsiAppId: "vpaas-magic-cookie-a7f253ed06694be591711007534e4db7",
  jitsiAppId: "vpaas-magic-cookie-e3a267fe77b54539abc0a4c9feeeed70",
  // jitsiDomain: "meet.truventor.com",
  tOneUrl: 'https://one.fe.truventor.com',
  tOneAPIUrl: 'https://one.stage.truventor.com/v1/auth/validate.token',
  tOneAdminUrl: 'https://admin.fe.truventor.com',
  zoomUserId: 'ZqaUV2CbQHOItxifcYUO8w',
  clientKeyOrSDKKey: 'uQA3OKGSSjic9pidjFCWqA'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

